// function menuSidebarMobile() {
//     var buttonIconOpen = $('.mobileMenu-toggle'),
//         buttonClose = $('.halo-sidebar-close, .background-overlay');

//     $(document).on('click', '.mobileMenu-toggle', function(event) {
//         event.preventDefault();
//         $('body').addClass('menu_open');
//             if(window.mobile_menu == 'default'){
//                 if(!$('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').length){
//                     var desktopMenu = $('.header-navigation .header__inline-menu, .header .header__inline-menu');
//                     if (desktopMenu.length) {
//                         desktopMenu.appendTo('#navigation-mobile .site-nav-mobile.nav');
//                         $('#navigation-mobile .site-nav-mobile.nav .list-menu-loading').hide();
//                     }
//                 }
//             }
//             if(!$('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').length){
//                 $('.header-top--wrapper .header-top--right .free-shipping-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
//             }
//             if(!$('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').length){
//                 $('.header-top--wrapper .header-top--right .customer-service-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
//             }
//             if(!$('#navigation-mobile .site-nav-mobile.nav-account .header__location').length){
//                 $('.header-top--wrapper .header-top--right .header__location').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
//             }
//             if(!$('#navigation-mobile .top-language-currency').length){
//                 if($('.header').hasClass('header-03')){
//                     $('.header .header-bottom-right .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
//                 }else if($('.header').hasClass('header-05')){
//                     $('.header .header-top--left .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
//                 }else{
//                     $('.header .header-language_currency .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
//                 }
//             }
//             // halo.productMenuSlider();
//     });

//     $(document).on('click', '.halo-sidebar-close, .background-overlay', function() {
//         $('body').removeClass('menu_open');
//         $('#navigation-mobile').off('transitionend.toggleCloseMenu').on('transitionend.toggleCloseMenu', () => {
//             if (!$('body').hasClass('menu_open')) {

//                 if(!$('#HeaderNavigation .header__inline-menu, .header-navigation .header__inline-menu, .header .header__inline-menu').length){
//                     var mobileMenu = $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu');
//                     if (mobileMenu.length) {
//                         var restoreContainer = $('#HeaderNavigation');
//                         if (restoreContainer.length) {
//                             mobileMenu.appendTo(restoreContainer);
//                         } else {
//                             if($('.header').hasClass('header-03') || $('.header').hasClass('header-04') || $('.header').hasClass('header-07') || $('.header').hasClass('header-08')){
//                                 mobileMenu.appendTo('.header .header-bottom--wrapper .header-bottom-left');
//                             }else{
//                                 mobileMenu.appendTo('.header .header-bottom--wrapper');
//                             }
//                         }
//                         $('#navigation-mobile .site-nav-mobile.nav .list-menu-loading').show();
//                     }
//                 }
//                 if(!$('.header-top--wrapper .header-top--right .free-shipping-text').length){
//                     if(!$('.header-04').hasClass('style_2')){
//                         $('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').insertBefore('.header-top--wrapper .header-top--right .header__group');
//                     }
//                 }
//                 if(!$('.header-top--wrapper .header-top--right .header__location').length){
//                     $('#navigation-mobile .site-nav-mobile.nav-account .header__location').insertBefore('.header-top--wrapper .header-top--right .header__group');
//                 }
//                 if(!$('.header-top--wrapper .header-top--right .customer-service-text').length){
//                     if($('.header').hasClass('header-03')){
//                         $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .header__group .header__icon--wishlist');
//                     }else{
//                         $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .top-language-currency');
//                     }
//                 }
//                 if(!$('.header-language_currency .top-language-currency').length){
//                     if($('.header').hasClass('header-03')){
//                         $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
//                     }else if($('.header').hasClass('header-04')){
//                         $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
//                     }else if($('.header').hasClass('header-05')){
//                         $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-top--wrapper .header-top--left .header-language_currency');
//                     }else{
//                         $('#navigation-mobile .site-nav-mobile .top-language-currency').insertBefore('.header .header-language_currency .header__search');
//                     }
//                 }
//             }
//         })
            
//     });

//     $(document).on('click', '.halo-sidebar-close', function (e) {
//         e.preventDefault();
//         e.stopPropagation();
//         $('body').removeClass('menu_open');
//     });
// }

// menuSidebarMobile();

function menuSidebarMobile() {
    var buttonIconOpen = $('.mobileMenu-toggle'),
        buttonClose = $('.halo-sidebar-close, .background-overlay');

    $(document).on('click', '.mobileMenu-toggle', function(event) {
        event.preventDefault();
        $('body').addClass('menu_open');
            if(window.mobile_menu == 'default'){
                if(!$('#navigation-mobile .site-nav-mobile.nav .header__inline-menu').length){
                    var desktopMenu = $('.header-navigation .header__inline-menu, .header .header__inline-menu');
                    if (desktopMenu.length) {
                        desktopMenu.appendTo('#navigation-mobile .site-nav-mobile.nav');
                        $('#navigation-mobile .site-nav-mobile.nav .list-menu-loading').hide();
                    }
                }
            }
            if(!$('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').length){
                $('.header-top--wrapper .header-top--right .free-shipping-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
            }
            if(!$('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').length){
                $('.header-top--wrapper .header-top--right .customer-service-text').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
            }
            if(!$('#navigation-mobile .site-nav-mobile.nav-account .header__location').length){
                $('.header-top--wrapper .header-top--right .header__location').appendTo('#navigation-mobile .site-nav-mobile.nav-account .wrapper-links');
            }
            if(!$('#navigation-mobile .top-language-currency').length){
                if($('.header').hasClass('header-03')){
                    $('.header .header-bottom-right .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
                }else if($('.header').hasClass('header-05')){
                    $('.header .header-top--left .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
                }else{
                    $('.header .header-language_currency .top-language-currency').appendTo('#navigation-mobile .site-nav-mobile.nav-currency-language');
                }
            }
            // halo.productMenuSlider();
    });

    $(document).on('click', '.halo-sidebar-close, .background-overlay', function() {
        $('body').removeClass('menu_open');
        $('#navigation-mobile').off('transitionend.toggleCloseMenu').on('transitionend.toggleCloseMenu', () => {
            if (!$('body').hasClass('menu_open')) {

                if(!$('#HeaderNavigation .header__inline-menu, .header-navigation .header__inline-menu, .header .header__inline-menu').length){
                    var mobileMenu = $('#navigation-mobile .site-nav-mobile.nav .header__inline-menu');
                    if (mobileMenu.length) {
                        var restoreContainer = $('#HeaderNavigation');
                        if (restoreContainer.length) {
                            mobileMenu.appendTo(restoreContainer);
                        } else {
                            if($('.header').hasClass('header-03') || $('.header').hasClass('header-04') || $('.header').hasClass('header-07') || $('.header').hasClass('header-08')){
                                mobileMenu.appendTo('.header .header-bottom--wrapper .header-bottom-left');
                            }else{
                                mobileMenu.appendTo('.header .header-bottom--wrapper');
                            }
                        }
                        $('#navigation-mobile .site-nav-mobile.nav .list-menu-loading').show();
                    }
                }
                if(!$('.header-top--wrapper .header-top--right .free-shipping-text').length){
                    if(!$('.header-04').hasClass('style_2')){
                        $('#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text').insertBefore('.header-top--wrapper .header-top--right .header__group');
                    }
                }
                if(!$('.header-top--wrapper .header-top--right .header__location').length){
                    $('#navigation-mobile .site-nav-mobile.nav-account .header__location').insertBefore('.header-top--wrapper .header-top--right .header__group');
                }
                if(!$('.header-top--wrapper .header-top--right .customer-service-text').length){
                    if($('.header').hasClass('header-03')){
                        $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .header__group .header__icon--wishlist');
                    }else{
                        $('#navigation-mobile .site-nav-mobile.nav-account .customer-service-text').insertBefore('.header-top--wrapper .header-top--right .top-language-currency');
                    }
                }
                if(!$('.header-language_currency .top-language-currency').length){
                    if($('.header').hasClass('header-03')){
                        $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
                    }else if($('.header').hasClass('header-04')){
                        $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-bottom--wrapper .header-bottom-right .header-language_currency');
                    }else if($('.header').hasClass('header-05')){
                        $('#navigation-mobile .site-nav-mobile .top-language-currency').appendTo('.header .header-top--wrapper .header-top--left .header-language_currency');
                    }else{
                        $('#navigation-mobile .site-nav-mobile .top-language-currency').insertBefore('.header .header-language_currency .header__search');
                    }
                }
            }
        })
            
    });

    $(document).on('click', '.halo-sidebar-close', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('body').removeClass('menu_open');
    });
}

menuSidebarMobile();

/* ============================================================
   Mobile Navigation: Submenu Toggle
   Clicking ANY part of a row that has child items (li.dropdown)
   opens the submenu instead of following the link.
   Clicking the back arrow (nav-title-mobile) goes up one level.
   Items WITHOUT children navigate normally.
============================================================ */
(function() {
    function handleMobileNavClick(event) {
        var target = event.target;

        // ── 1. Back button (nav-title-mobile or any child of it) ─────────────
        var backBtn = target.closest('.nav-title-mobile');
        if (backBtn) {
            event.preventDefault();
            event.stopPropagation();
            var openParent = backBtn.closest('.menu-lv-item.is-open');
            if (openParent) {
                openParent.classList.remove('is-open');
            }
            return;
        }

        // ── 2. Any click INSIDE an already-open dropdown submenu panel ────────
        //    (let those clicks through so child links / back-button work)
        var insideDropdown = target.closest('.menu-lv__dropdownmenu, .menu-lv__dropdownmenu-3, .list-menu--disclosure-1, .list-menu--disclosure-2');
        if (insideDropdown) {
            // Only handle if the click is on a child item that ALSO has a
            // sub-submenu (lv-2 -> lv-3). Otherwise let the link navigate.
            var lv2WithSub = target.closest('.menu-lv-item.menu-lv-2.dropdown, .menu-lv-item.menu-lv-3.dropdown');
            if (lv2WithSub) {
                // Check the click wasn't on the nav-title (already handled above)
                var lv2Link = target.closest('.menu_mobile_link, .menu-lv-2__action, .menu-lv-3__action');
                if (lv2Link) {
                    event.preventDefault();
                    event.stopPropagation();
                    var lv2Container = lv2WithSub.parentElement;
                    if (lv2Container) {
                        lv2Container.querySelectorAll(':scope > .menu-lv-item.is-open').forEach(function(sib) {
                            if (sib !== lv2WithSub) sib.classList.remove('is-open');
                        });
                    }
                    lv2WithSub.classList.toggle('is-open');
                }
            }
            return;
        }

        // ── 3. Top-level row click on ANY part of a lv-1 .dropdown item ───────
        //    This catches clicks on the text, icon, or anywhere in the row.
        var lv1Item = target.closest('.menu-lv-item.dropdown');
        if (lv1Item) {
            event.preventDefault();
            event.stopPropagation();
            // Close siblings
            var container = lv1Item.parentElement;
            if (container) {
                container.querySelectorAll(':scope > .menu-lv-item.is-open').forEach(function(sib) {
                    if (sib !== lv1Item) sib.classList.remove('is-open');
                });
            }
            lv1Item.classList.toggle('is-open');
        }
    }

    function attachMobileNavListener() {
        var navMobile = document.getElementById('navigation-mobile');
        if (!navMobile || navMobile.dataset.submenuBound) return;
        navMobile.dataset.submenuBound = '1';
        navMobile.addEventListener('click', handleMobileNavClick);
    }

    // Attach immediately (covers custom-menu mode where content is pre-rendered)
    document.addEventListener('DOMContentLoaded', attachMobileNavListener);

    // Re-attach after the hamburger toggle (default mode injects menu dynamically)
    $(document).on('click', '.mobileMenu-toggle', function() {
        setTimeout(attachMobileNavListener, 400);
    });
})();